// src/components/utils/Validaciones.js

const mostrarError = (toastRef, mensaje) => {  
  const toastFn = toastRef?.current;

  if (!toastFn || typeof toastFn.show !== 'function') {
  console.error('❌ toastRef no es válido:', toastRef?.current, mensaje);
  return;
} else {
  console.log('✅ Mostrando toast con mensaje:', mensaje);
}
  toastFn.show({
    severity: 'error',
    summary: 'Error',
    detail: mensaje,
    life: 5000
  });
};

const Validaciones = {
  validarCamposRequeridos(product, toastRef, puntaje) {
    if (product.TID_PROPIETARIO === '') {
      mostrarError(toastRef, 'Debe seleccionar el tipo de documento del Propietario, verifique por favor...');
      return false;
    }
    if (product.NID_PROPIETARIO === '') {
      mostrarError(toastRef, 'Debe seleccionar el Propietario, verifique por favor...');
      return false;
    }
    if (product.COMPOSICION === '') {
      mostrarError(toastRef, 'Debe digitar la composicion racial, verifique por favor...');
      return false;
    }
    if (product.CONSECUTIVO === '') {
      mostrarError(toastRef, 'Debe seleccionar el consecutivo, verifique por favor...');
      return false;
    }
    if (product.FECHA_SOLICITUD === '') {
      mostrarError(toastRef, 'Debe seleccionar la fecha de solicitud, verifique por favor...');
      return false;
    }
    if (product.ESPECIE === '') {
      mostrarError(toastRef, 'Debe seleccionar la especie, verifique por favor...');
      return false;
    }
    if (product.COLOR === '') {
      mostrarError(toastRef, 'Debe digitar el color de la especie, verifique por favor...');
      return false;
    }
    if (product.CHIP === '') {
      mostrarError(toastRef, 'Debe seleccionar el CHIP, verifique por favor...');
      return false;
    }
    if (product.COMPOSICION === 'FU') {
      if (product.CHIP === '') {
        mostrarError(toastRef, 'Debe digitar el puntaje del fundador, verifique por favor...');
        return false;
      } else if (product.SEXO === 'M') {
        if (product.PUNTAJE_FUNDADORES < puntaje) {
          mostrarError(toastRef, `El puntaje asignado al macho es inferior al permitido de ${puntaje}`);
          return false;
        }
      } else {
        if (product.PUNTAJE_FUNDADORES < puntaje) {
          mostrarError(toastRef, `El puntaje asignado a la hembra es inferior al permitido de ${puntaje}`);
          return false;
        }
      }
    }
    if (product.COMPOSICION === 'FU' && product.SEXO === 'M') {
      if (localStorage.getItem('administrador') == 1) {
        if (product.TID_REGISTRADOR === '') {
          mostrarError(toastRef, 'Debe seleccionar el tipo de documento del registrador, verifique por favor...');
          return false;
        }
        if (product.NID_REGISTRADOR === '') {
          mostrarError(toastRef, 'Debe seleccionar el registrador, verifique por favor...');
          return false;
        }
      }
      if (product.TID_REGISTRADOR1 === '') {
        mostrarError(toastRef, 'Debe seleccionar el tipo de documento del registrador 2, verifique por favor...');
        return false;
      }
      if (product.NID_REGISTRADOR1 === '') {
        mostrarError(toastRef, 'Debe seleccionar el registrador 2, verifique por favor...');
        return false;
      }
      if (product.TID_REGISTRADOR2 === '') {
        mostrarError(toastRef, 'Debe seleccionar el tipo de documento del registrador 3, verifique por favor...');
        return false;
      }
      if (product.NID_REGISTRADOR2 === '') {
        mostrarError(toastRef, 'Debe seleccionar el registrador 3, verifique por favor...');
        return false;
      }
    } else if (product.COMPOSICION === 'FU' && product.SEXO === 'H') {
      if (localStorage.getItem('administrador') == 1) {
        if (product.TID_REGISTRADOR === '') {
          mostrarError(toastRef, 'Debe seleccionar el tipo de documento del registrador, verifique por favor...');
          return false;
        }
        if (product.NID_REGISTRADOR === '') {
          mostrarError(toastRef, 'Debe seleccionar el registrador, verifique por favor...');
          return false;
        }
      }
    }
    if (product.RAZA === '') {
      mostrarError(toastRef, 'Debe seleccionar la raza del animal, verifique por favor...');
      return false;
    }
    if (product.COMPOSICION === 'PP') {
      if (product.CHIP_ABUELO_PATERNO === '') {
        mostrarError(toastRef, 'Debe digitar el Chip del Abuelo Paterno, verifique por favor...');
        return false;
      }
      if (product.CHIP_ABUELA_PATERNA === '') {
        mostrarError(toastRef, 'Debe digitar el Chip de la Abuela Paterna, verifique por favor...');
        return false;
      }
      if (product.CHIP_ABUELO_MATERNO === '') {
        mostrarError(toastRef, 'Debe digitar el Chip del Abuelo Materno, verifique por favor...');
        return false;
      }
      if (product.CHIP_ABUELA_MATERNA === '') {
        mostrarError(toastRef, 'Debe digitar el Chip de la Abuela Materna, verifique por favor...');
        return false;
      }
    }

    return true;
  }
};

export default Validaciones;
